import React from 'react';
import Card from './Card';
import Text from './Text';

export interface QaCardProps {
  question: string;
  answer: React.ReactNode;
  tone?: 'paper' | 'mist';
}

/** Domanda e risposta sempre aperte: la risposta è contenuto, non un dettaglio. */
const QaCard = ({ question, answer, tone = 'paper' }: QaCardProps) => (
  <Card tone={tone} padding="sm" className="p-6 sm:px-[1.625rem] sm:py-6">
    <h3 className="font-display text-[1.0625rem] font-semibold text-primary">{question}</h3>
    {/* div, non p: la risposta può avere più paragrafi e un elenco */}
    <Text as="div" size="intro" className="mt-2.5 text-[0.9375rem] leading-[1.65]">
      {answer}
    </Text>
  </Card>
);

export default QaCard;
